import type { MessageDeliveryState } from '@fluenceur/types';

/**
 * The delivery states this build words, each owning a key under
 * `messages.delivery.*`. Exhaustive over the contract: a state added there
 * without its words fails to compile here.
 */
const KNOWN_DELIVERY_STATES: Record<MessageDeliveryState, true> = {
  failed: true,
  pending: true,
  sent: true,
  unknown: true,
};

/**
 * The key wording a sent message's state, or nothing at all when the state is
 * one this build has never heard of.
 *
 * The column is free text and older rows still carry states the vocabulary has
 * since dropped, so an unknown value is ordinary data rather than a defect. The
 * caller falls back to the hour alone: a raw translation key on a bubble would
 * be worse than saying nothing.
 */
export const selectDeliveryStateKey = (deliveryState: string): string | null =>
  deliveryState in KNOWN_DELIVERY_STATES ? `messages.delivery.${deliveryState}` : null;
